import { useState, useEffect } from 'react';

export function useActiveSection(sectionIds: string[], scrollOffset = 80) {
    const [activeSection, setActiveSection] = useState<string>('');
    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            let current = '';
            for (const id of sectionIds) {
                const el = document.getElementById(id);
                if (el) {
                    const offsetTop = el.offsetTop - scrollOffset;
                    const offsetBottom = offsetTop + el.offsetHeight;
                    if (scrollY >= offsetTop && scrollY < offsetBottom) {
                        current = id;
                        break; // нашли текущий активный раздел, выходим из цикла
                    }
                }
            }
            setActiveSection(current); // если current пустой, значит вне секций — выделение убирается
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [sectionIds, scrollOffset]);
    return activeSection;
}
